module.exports = __webpack_public_path__ + "520c3fa60f826ff2d046efec002e39f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/expression-shock.png
// module id = 2322
// module chunks = 0